/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { FaStore, FaPaintBrush, FaRocket } from "react-icons/fa";
import { COLORS } from "./about.constants";

export default function AboutStepCard({ index, title, desc }) {
  return (
    <div
      className="p-4"
      style={{
        background: "rgba(255, 255, 255, 0.08)",
        borderRadius: 16,
        width: 300,
        color: COLORS.textLight,
        border: "1px solid rgba(255,255,255,0.15)",
        transition: "transform 0.3s ease",
        boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.transform = "translateY(-6px)")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.transform = "translateY(0)")
      }
    >
      <div
        style={{
          width: 90,
          height: 90,
          margin: "0 auto 20px",
          borderRadius: "50%",
          background: COLORS.gold,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        {index === 0 && <FaStore size={42} color={COLORS.darkPurple} />}
        {index === 1 && <FaPaintBrush size={42} color={COLORS.darkPurple} />}
        {index === 2 && <FaRocket size={42} color={COLORS.darkPurple} />}
      </div>

      <h5
        className="fw-bold mb-2"
        style={{
          color: COLORS.gold,
          fontSize: "1.25rem",
          fontFamily: "'Cairo', sans-serif",
          fontWeight: 700,
        }}
      >
        {title}
      </h5>

      <p
        style={{
          color: COLORS.textLight,
          fontSize: "1rem",
          lineHeight: "1.7",
          fontFamily: "'Tajawal', sans-serif",
        }}
      >
        {desc}
      </p>
    </div>
  );
}
